import styled from 'styled-components'

export const BackgroundLarge = styled.div`
  background-color: #1F2023;
`

export const HeadlineOne = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #F6F6F6;
  line-height: 75%;
  user-select: none;
  transform: translate(0,100%);
`

export const HeadlineTwo = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #F6F6F6;
  margin-left: 34vh;
  line-height: 75%;
  user-select: none;
  transform: translate(0,100%);
`

export const HeadlineThree = styled.div`
  font-family: 'reason01';
  font-size: 43vh;
  color: #F6F6F6;
  line-height: 75%;
  user-select: none;
  transform: translate(0,100%);
`

export const Wrapper = styled.div`
  overflow: hidden;
`

export const HeadlineWrapper = styled.div`
  position: absolute;
  margin-top: 2vh;
  left: 1vh;
`
